module.exports = __webpack_public_path__ + "static/media/compiler-logo.5d3e0eb0.svg";